import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../components/login/Login";
import Home from "../views/Home.vue";
import Register from "../components/login/Register";
import Admin from "../components/admin/Admin";
import Settings from "../components/settings/Settings";
import Category from "../components/layout/category/Category";
import ViewCategory from "../components/layout/documents/ViewCategory";
import ViewSubCategoryDocuments from "../components/layout/documents/ViewSubCategoryDocuments";
import firebase from "firebase/app";
import "firebase/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Category",
    component: Category,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      requiresGuest: true,
    },
  },

  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: "/category/:categoryId",
    name: "ViewCategory",
    component: ViewCategory,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/category/:categoryId/:secondaryId",
    name: "ViewSubCategoryDocuments",
    component: ViewSubCategoryDocuments,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/temp/homepage",
    name: "Home",
    component: Home,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// nav gaurds
router.beforeEach((to, from, next) => {
  let user = firebase.auth().currentUser;
  if (to.matched.some((rec) => rec.meta.requiresAuth)) {
    if (user) {
      next();
    } else {
      next({ name: "Login" });
    }
  } else if (to.matched.some((rec) => rec.meta.requiresGuest)) {
    if (user) {
      next({ name: "Category" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
